import { Navbar } from "../home/Navbar";
import { Footer } from "../home/Footer";

export const PageShell = ({ children }) => (
  <div className="bg-[#080B12] min-h-screen">
    <Navbar />
    <main>{children}</main>
    <Footer />
  </div>
);
